import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Home from '../Components/Home/Main';

const ROUTE_TO_SECTION = {
  '/story': 'services',
  '/music': 'music',
  '/features': 'key_features',
  '/review': 'reviews',
  '/approved_kids': 'approved_kids',
  '/faq': 'faq',
};

const Routing = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/story" element={<Home />} />
        <Route path="/music" element={<Home />} />
        <Route path="/features" element={<Home />} />
        <Route path="/review" element={<Home />} />
        <Route path="/approved_kids" element={<Home />} />
        <Route path="/faq" element={<Home />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </>
  );
};

export default Routing;
export { ROUTE_TO_SECTION };
